import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const rootApi = createApi({
    baseQuery: fetchBaseQuery({ baseUrl: "/api", credentials: "include" }),
    endpoints: () => ({}),
});
